import { NoSoundIcon } from '@/components/icons/no-sound';
import { SoundIcon } from '@/components/icons/sound';
import { useVideoStore } from '../hooks/use-video-store';
import { Button } from './button';

export function MuteUnmuteButton() {
  const { isMuted, toggleMute } = useVideoStore((state) => ({
    isMuted: state.isMuted,
    toggleMute: state.toggleMute,
  }));

  return (
    <Button
      label={isMuted ? 'UnMute video' : 'Mute video'}
      icon={isMuted ? <NoSoundIcon /> : <SoundIcon />}
      onClick={toggleMute}
    />
  );
}
